import { useSearchParams } from 'react-router';
import { Tabs, TabsContent } from '@/components/ui/tabs';
import { FundReportsPanel } from '@/components/reports/FundReportsPanel';
import { NewReportButton } from '@/components/reports/NewReportButton';
import { ReportTemplatesSection } from '@/components/reports/ReportTemplatesSection';

export function FundReportsTab({ fundId }: { fundId: string }) {
  const [searchParams] = useSearchParams();
  const activeSubTab = searchParams.get('section') || 'list';

  return (
    <TabsContent value="reports" className="space-y-4">
      <Tabs value={activeSubTab}>
        <TabsContent value="list" className="space-y-4">
          <div className="flex justify-end">
            <NewReportButton fundId={fundId} />
          </div>
          <FundReportsPanel fundId={fundId} />
        </TabsContent>
        <TabsContent value="templates">
          <ReportTemplatesSection fundId={fundId} />
        </TabsContent>
      </Tabs>
    </TabsContent>
  );
}
